import { startTransition, StrictMode, useEffect } from 'react';
import { hydrateRoot } from 'react-dom/client';
import { RemixBrowser } from '@remix-run/react';
import { useLocation, useMatches } from '@remix-run/react';
import * as Sentry from '@sentry/remix';

import { parseSentryVars, SentrySchema } from './sentry';
import { z } from 'zod';

declare global {
  interface Window {
    __SENTRY_VARS__: z.infer<typeof SentrySchema> | unknown;
  }
}

export const init = () => {
  if (import.meta.env.PROD) {
    Sentry.init({
      ...parseSentryVars(window.__SENTRY_VARS__),
      integrations: [
        Sentry.browserTracingIntegration({
          useEffect,
          useLocation,
          useMatches,
        }),
        // Replay is only available in the client
        Sentry.replayIntegration(),
      ],

      // Set tracesSampleRate to 1.0 to capture 100%
      // of transactions for performance monitoring.
      // We recommend adjusting this value in production
      tracesSampleRate: 0.2,

      // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
      // TODO add later
      // tracePropagationTargets: ['localhost', /^https:\/\/yourserver\.io\/api/],

      // Capture Replay for 10% of all sessions,
      // plus for 100% of sessions with an error
      replaysSessionSampleRate: 0.1,
      replaysOnErrorSampleRate: 1.0,
    });
  }

  startTransition(() => {
    hydrateRoot(
      document,
      <StrictMode>
        <RemixBrowser />
      </StrictMode>,
    );
  });
};
